import { Link } from 'react-router-dom';

import { AuthShell } from '@/components/auth/auth-shell';
import { Button } from '@/components/ui/button';

/**
 * AUTH-07 — Session Expired.
 *
 * Standalone screen navigated to when:
 *  - MFA verification returns 401 (too many attempts / session timeout)
 *  - Any authenticated API call gets a 401 via the axios interceptor
 *
 * Figma: Mobile-only frame 195:19 — extrapolated to the shared split-hero
 * layout for desktop consistency (no desktop variant in Figma).
 */
export function SessionExpiredPage() {
  return (
    <AuthShell
      title="Session Expired"
      description="Your session has expired. Please sign in again to continue."
    >
      <div className="flex flex-col items-center gap-4 py-2">
        <Button asChild className="w-full">
          <Link to="/login">Sign In Again</Link>
        </Button>
      </div>
    </AuthShell>
  );
}
